import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { dt } from "./format";
import { Select } from "./ui";

export function ActivityTab() {
  const orgs = trpc.platform.orgs.list.useQuery();
  const [orgId, setOrgId] = useState("");
  const q = trpc.platform.activity.recent.useQuery({ limit: 150, orgId: orgId || undefined });

  return (
    <div className="pf-grid" style={{ gap: 18 }}>
      <div className="pf-row" style={{ flexWrap: "wrap" }}>
        <div>
          <h2 className="pf-title">Aktivität</h2>
          <p className="pf-lead">Das Protokoll aller Betriebe — wer hat wann was getan.</p>
        </div>
        <div style={{ flex: 1 }} />
        <div style={{ width: 260 }}>
          <Select value={orgId} onChange={(e) => setOrgId(e.target.value)} options={[{ value: "", label: "Alle Betriebe" }, ...(orgs.data ?? []).map((o) => ({ value: o.id, label: o.legalName }))]} />
        </div>
      </div>
      <div className="pf-card pf-table-wrap">
        <table className="pf-table">
          <thead><tr><th>Zeit</th><th>Betrieb</th><th>Wer</th><th>Was</th></tr></thead>
          <tbody>
            {(q.data ?? []).map((a) => (
              <tr key={a.id}>
                <td className="pf-mono" style={{ color: "var(--pf-text-2)", whiteSpace: "nowrap", fontSize: 12 }}>{dt(a.at)}</td>
                <td>{a.org}</td>
                <td>{a.who}</td>
                <td style={{ color: "var(--pf-text-2)" }}>{a.what}</td>
              </tr>
            ))}
            {!q.isLoading && !q.data?.length && <tr><td colSpan={4} className="pf-empty">Keine Aktivität.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
